import { jsx as _jsx } from "react/jsx-runtime";
import { Check, Close } from "@mui/icons-material";
import { Badge, IconButton, Popover, } from "@mui/material";
import { Clock } from "mdi-material-ui";
import { TASK_STATUS } from "../../lib/index.js";
export const STATUS_POPOVER_Z_INDEX = 11000;
export const StatusBadge = ({ children, taskGroups, hasError = false, }) => {
    const attentionCount = taskGroups.filter((tasks) => tasks.some(({ status }) => status === TASK_STATUS.current)).length;
    const isWaiting = attentionCount === 0 &&
        taskGroups.some((tasks) => tasks.some(({ status }) => status === TASK_STATUS.pendingApproval ||
            status === TASK_STATUS.future));
    const allTasksComplete = taskGroups.length > 0 &&
        taskGroups.every((tasks) => tasks.every(({ status }) => status === TASK_STATUS.completed));
    return (_jsx(Badge, { badgeContent: hasError ? (_jsx(Close, { sx: { fontSize: 12 } })) : allTasksComplete ? (_jsx(Check, { sx: { fontSize: 12 } })) : isWaiting ? (_jsx(Clock, { color: "info", sx: { width: 19 } })) : (attentionCount), color: hasError
            ? "error"
            : allTasksComplete
                ? "success"
                : isWaiting
                    ? "default"
                    : "warning", sx: {
            "& .MuiBadge-badge": {
                fontSize: (theme) => theme.typography.pxToRem(9),
                height: 16,
                minWidth: 16,
                width: 16,
            },
        }, children: children }));
};
export const StatusIconButton = ({ size = "small", sx, ...props }) => (_jsx(IconButton, { ...props, size: size, sx: [
        {
            bgcolor: "transparent",
            borderRadius: 1.5,
            color: "text.secondary",
            "&:hover": { bgcolor: "action.selected" },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ] }));
export const StatusPopover = ({ sx, ...props }) => (_jsx(Popover, { ...props, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" }, sx: [
        { zIndex: STATUS_POPOVER_Z_INDEX },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ], slotProps: {
        paper: {
            sx: {
                mt: 0.5,
                width: 350,
                maxWidth: "calc(100vw - 32px)",
                maxHeight: "70vh",
                borderRadius: 2,
            },
        },
    } }));
//# sourceMappingURL=StatusContainers.js.map